// Base metadata for each route
export const baseMetadata = {
  '/': {
    title: 'Home | Sesame Workshop Outdoor Learning Hub',
    description: 'Welcome to Sesame Workshop Outdoor Learning Hub',
    keywords: 'outdoor learning, education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/library': {
    title: 'Library | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'library, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/collections': {
    title: 'Collections | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'collections, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/find': {
    title: 'Find | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'find, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/all-cards': {
    title: 'All Cards | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'all cards, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/recent': {
    title: 'Recent | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'recent, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/favorites': {
    title: 'Favorites | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'favorites, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
  '/share': {
    title: 'Share | Sesame Workshop Outdoor Learning Hub',
    description: 'Learn about our outdoor learning program',
    keywords: 'share, outdoor education, Sesame, Sesame Workshop Outdoor Learning Hub',
  },
};

export const subPageMetadata = {
  '/card/{id}': {
    title: `{title} | Sesame Workshop Outdoor Learning Hub`,
    description: `{description} | Explore this activity card`,
    keywords: `{title}, outdoor learning, activities, Sesame, Sesame Workshop Outdoor Learning Hub`,
  },
  '/collections/{id}': {
    title: `{name} Collection | Sesame Workshop Outdoor Learning Hub`,
    description: `Explore the {name} collection of activity cards`,
    keywords: `{name} collection, outdoor learning, activities, Sesame, Sesame Workshop Outdoor Learning Hub`,
  },
};

export const combinedMetadata = { ...baseMetadata, ...subPageMetadata };
